import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { useStore } from "@/context/StoreContext";

function Shell({ testid, title, children }) {
  return (
    <div data-testid={testid} className="flex min-h-[80vh] flex-col items-center justify-center bg-[#EDECE9] px-6 pt-28 text-center">
      <p className="overline text-clay">M. Kingsley Studio</p>
      <h1 className="mt-5 max-w-xl font-display text-4xl font-extralight tracking-tight text-ink sm:text-5xl">{title}</h1>
      <div className="mt-6 max-w-md font-body text-sm leading-relaxed text-stone">{children}</div>
      <Link to="/kingsley" data-testid="payment-back-boutique" className="link-underline overline mt-10 text-ink">Back to the boutique</Link>
    </div>
  );
}

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clear } = useCart();
  const { reload } = useStore();
  const [state, setState] = useState({ status: "checking", order: null });

  useEffect(() => {
    if (!sessionId) return setState({ status: "error" });
    let tries = 0, stop = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          clear();
          reload();
          return setState({ status: "paid", order: data.order_id });
        }
      } catch { /* retry */ }
      if (!stop && ++tries < 10) setTimeout(poll, 2000);
      else if (!stop) setState({ status: "pending" });
    };
    poll();
    return () => { stop = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  if (state.status === "paid")
    return (
      <Shell testid="payment-success" title="Thank you — your order is in.">
        Order <span data-testid="payment-order-id" className="font-mono text-ink">{state.order}</span>. A receipt is on its way to your email,
        and I’ll be in touch as your piece is made and shipped.
      </Shell>
    );
  if (state.status === "checking") return <Shell testid="payment-checking" title="Confirming your payment…">One moment.</Shell>;
  return (
    <Shell testid="payment-pending" title="We’re still confirming your payment.">
      If you completed checkout you’ll receive a receipt by email shortly. Questions? Reach out through the contact page.
    </Shell>
  );
}

export function PaymentCancel() {
  return (
    <Shell testid="payment-cancel" title="Checkout was cancelled.">
      Nothing was charged. Your bag is saved whenever you’re ready.
    </Shell>
  );
}
